import { createContext, ReactNode } from "react";
import useResize from "../custom_hooks/useResize.tsx";

interface WrapperContextProps {
    headerData: object;
    children: ReactNode;
}

export const WrapperContext = createContext({
    headerData: {},
    isMobile: false,
});

const Wrapper = (props: WrapperContextProps) => {
    const isMobile = useResize() <= 750;

    return <WrapperContext.Provider value={{ headerData: props.headerData, isMobile }}>{props.children}</WrapperContext.Provider>;
};

export default Wrapper;
